export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-9010HD_white-e3d02cef9bfabc807ad38a105c87163b.webp";